import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, first, map } from 'rxjs/operators';
import { getCurrentTenant } from '../../core/states/tenant-state/tenant.selectors';
import { Tenant } from '../../core/declarations/tenant.interface';

export const maintenanceModeGuard = () => {
  const tenantStore = inject(Store<Tenant>);
  const router = inject(Router);

  return tenantStore.select(getCurrentTenant).pipe(
    filter(t => t !== 'loading'),
    map(t => t as Tenant),
    first(),
    map(tenant => {
      const maintenanceEnabled =
        tenant?.tenant_setting?.maintanance_enabled ||
        // Until releasing new BE, this setting is not available in Flink 1.0
        (tenant?.tenant_setting &&
          !Object.prototype.hasOwnProperty.call(
            tenant.tenant_setting,
            'maintanance_enabled'
          ));

      // If maintenance is enabled, redirect to maintenance page
      if (maintenanceEnabled) {
        return router.createUrlTree(['/maintenance']);
      }

      return true;
    })
  );
};
